import styled from 'styled-components';
import { TTButton } from '../../components/TableComponents';

export const DeploySummaryButton = styled(TTButton)`
  width: auto !important;
  background-color: white;
  border-radius: 4px;
  margin-bottom: 10px;
  color: white;

  &:hover {
    color: white !important;
  }
`;

export const DeployButton = styled(TTButton)`
  border-radius: 4px;
  margin-left: 18px;
`;
